import { render, staticRenderFns } from "./bannerdetails.vue?vue&type=template&id=191bd846&scoped=true"
import script from "./bannerdetails.vue?vue&type=script&lang=js"
export * from "./bannerdetails.vue?vue&type=script&lang=js"
import style0 from "./bannerdetails.vue?vue&type=style&index=0&id=191bd846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191bd846",
  null
  
)

export default component.exports